import { TextAreaField } from "@/components/TextAreaField/TextAreaField";
import { useAuth } from "@/hooks/auth";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  disabled: boolean;
};

const AssetDisclaimer = ({ disabled }: Props) => {
  const { activeAsset, updateMetadata, isMetadataUpdating } =
    useMetadataFields();
  const isUpdating = isMetadataUpdating(activeAsset.id!, "disclaimer");
  const isAdmin = useAuth().user.isAdmin;
  const value = isAdmin ? activeAsset.disclaimer : activeAsset.userDisclaimer;
  return (
    <TextAreaField
      id="disclaimerText"
      type="textarea"
      labelText="Asset disclaimer"
      toolTipText="Does the asset have disclaimer text"
      initialValue={value || ""}
      helperMsg={isAdmin && activeAsset.userDisclaimer}
      disabled={disabled || isUpdating}
      onBlur={(value: string) =>
        updateMetadata(
          isAdmin ? { disclaimer: value } : { userDisclaimer: value },
        )
      }
    />
  );
};

export default AssetDisclaimer;
